import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Statistics').create(({ theme }) => ({
  rootWrapper: {
    border: '1px solid',
    position: 'relative',
    borderColor: theme.colors.borders.secondary,
    height: '128px',
    overflow: 'hidden',
    borderRadius: '16px',
  },

  root: {
    display: 'flex',
    height: '100%',
    padding: '14px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    background: theme.colors.button.secondary.background,

    '&[data-ispremium="true"]': {
      background: 'rgba(47, 57, 99, 1)',
    },
    '&[data-islocked="true"]': {
      filter: 'blur(10px)',
    },
  },

  value: {
    color: theme.colors.text.primary,

    textAlign: 'center',

    fontSize: '34px',

    fontWeight: '800',

    lineHeight: '34px',

    '&[data-name="Registration Date"]': {
      fontSize: '24px',
    },
    '&[data-name="K/D"]': {
      fontSize: '24px',
    },
    '&[data-name="Дата регистрации"]': {
      fontSize: '24px',
    },
    '&[data-name="КД"]': {
      fontSize: '24px',
    },
  },

  name: {
    color: theme.colors.text.secondary,

    textAlign: 'center',

    fontSize: '17px',

    fontWeight: '350',
    lineHeight: '17px',
    letterSpacing: -'0.17px',
  },

  premiumLockerWrapper: {
    zIndex: 5,
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    gap: '2px',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  premiumText: {
    textAlign: 'center',
    fontSize: theme.sizes.texts.fontSize.m,
    fontWeight: '350',
    color: theme.colors.text.primary,
  },

  valueAndProgressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
  },

  progressWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',

    span: {
      fontSize: '18px',
      fontWeight: 450,
      lineHeight: '18px',

      '&[data-ispositive="true"]': {
        color: '#1EFF00',
      },
      '&[data-ispositive="false"]': {
        color: theme.colors.text.error,
      },
    },
  },
}))
